import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { WhatsApp } from '@material-ui/icons'

import { useSelectors } from '../../store'
import { whatsappChatProps } from '../whatsapp-chat'
import { AnalyticsService } from '../../services/analytics'
import { SAME_DAY_OFFER, sameDayWhatsappText } from '../../lib/same-day-offer'
import { styles } from './styles'

// Once per module (booking screen, 11 Oct 2026).
const useStyles = makeStyles(styles)

// "Need it today? WhatsApp us and we'll try to fit you in", and a button
// that opens WhatsApp with "Hi, I'd like a <wash> today in <outward
// postcode>, is there any chance?" (lib/same-day-offer.js). reason: why it
// shows ('today_selected' | 'moved' | 'too_late'), on
// same_day_whatsapp_tapped. getPostcode: the postcode as typed, read at the
// tap so the message names the latest one.
export const SameDayOffer = ({ reason, getPostcode }) => {
  const classes = useStyles()
  const { baseService } = useSelectors()
  const text = sameDayWhatsappText({ wash: baseService?.name, postcode: getPostcode ? getPostcode() : null })
  const link = whatsappChatProps(text)
  return (
    <div className={classes.offer} data-testid="same-day-offer">
      <span className={classes.text}>{SAME_DAY_OFFER}</span>
      <a
        {...link}
        className={classes.button}
        data-testid="same-day-whatsapp"
        onClick={e => {
          AnalyticsService.trackSameDayWhatsappTapped(reason)
          link.onClick(e)
        }}>
        <WhatsApp style={{ fontSize: 18, marginRight: 6 }} />
        WhatsApp us
      </a>
    </div>
  )
}
